import React, { useEffect, useState } from "react";
import "./opd.css";

import { TextField, InputAdornment } from "@mui/material";
import { 
  Delete, 
  Phone, 
  Person, 
  AttachMoney,
  Payment,
  CheckCircle,
  Pending,
  LocalHospital,
  Event,
  Search,
  MedicalServices,
  Add,
  ConfirmationNumber
} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebaseConfig/firebase";
import OpdPay from "./OpdPay";
import OpdNextAppt from "./OpdNextAppt";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function Opd() {
  const [open, setOpen] = useState(false);
  const [opdidC, setOpdId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  
  const handleCloseYES = async () => {
    setShowAlert(true);
    await deleteDoc(doc(db, "opdEntry", opdidC));
    setTimeout(() => setShowAlert(false), 2000);
    setOpen(false);
  };

  const [date, setDate] = useState(new Date(Date.now()));
  let datew = JSON.stringify(date);
  datew = datew.slice(1, 11);

  let navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    const opdData = collection(db, "opdEntry");

    const qd = query(
      opdData,
      where("date", "==", datew),
      orderBy("created", "desc")
    );

    const unsub = onSnapshot(qd, (snap) => {
      let newArray = [];

      snap.forEach((doc) => {
        newArray.push({
          ...doc.data(),
          opdId: doc.id,
          id: doc.get("ptId"),
          ptName: doc.get("ptName"),
          name: doc.get("ptName"),
          opdPay: doc.get("opdPay"),
          phNumber: doc.get("phNumber"),
          phoneNumber: doc.get("phNumber"),
          paymentMode: doc.get("paymentMode"),
          gender: doc.get("gender"),
          askPrice: doc.get("askPrice"),
          date: doc.get("date"),
          tokenNumber: doc.get("tokenNumber"),
          age: doc.get("age"),
          ptCreatedDate: doc.get("ptCreatedDate"),
          totalPaid: doc.get("totalPaid"),
          TotalAmount: doc.get("TotalAmount"),
          status: doc.get("status"),
          created: doc.get("created"),
          amountFor: doc.get("amountFor"),
          photoURL: doc.get("photoURL"),

          // Next Appointment Fields
          nextApptOption: doc.get("nextApptOption") || "none",
          nextApptType: doc.get("nextApptType") || "None",
          nextApptWork: doc.get("nextApptWork") || "",
          nextApptDate: doc.get("nextApptDate") || "",
          nextApptDuration: doc.get("nextApptDuration") || "",
          isApptGiven: doc.get("isApptGiven") === true,
        });
      });

      setData(newArray);
    });

    return () => {
      unsub();
    };
  }, [datew]);

  // Filter patients based on search query
  const filteredData = data.filter((item, idx) => {
    const ptName = (item.ptName || item.name || "").toLowerCase();
    const phone = (item.phNumber || item.phoneNumber || "").toString();
    const tokenStr = (item.tokenNumber || (idx + 1)).toString();
    const q = searchQuery.toLowerCase().trim();
    return ptName.includes(q) || phone.includes(q) || tokenStr.includes(q);
  });

  const paidCount = data.filter((i) => i.status === "approved").length;
  const pendingCount = data.length - paidCount;

  return (
    <Box sx={{ 
      minHeight: "100vh", 
      backgroundColor: "#f4f6f9",
      pb: "110px"
    }}>
      {/* Success Alert */}
      {showAlert && (
        <Stack
          sx={{ 
            width: "100%", 
            position: "fixed", 
            top: "12px",
            zIndex: "9999",
            px: 2
          }}
          spacing={2}
        >
          <Alert 
            severity="success" 
            sx={{ 
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
              fontSize: "14px",
              fontWeight: 600
            }}
          >
            <AlertTitle sx={{ fontWeight: 700 }}>Success</AlertTitle>
            Patient deleted from OPD queue successfully
          </Alert>
        </Stack>
      )}

      {/* Header Bar */}
      <Box
        sx={{
          background: "linear-gradient(135deg, rgb(5, 2, 43) 0%, rgb(18, 25, 75) 100%)",
          color: "white",
          px: 2.5,
          pt: 2.5,
          pb: 3,
          borderRadius: "0 0 24px 24px",
          boxShadow: "0 4px 20px rgba(5, 2, 43, 0.25)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        {/* Decorative Circles */}
        <Box sx={{
          position: "absolute",
          top: "-40px",
          right: "-40px",
          width: "180px",
          height: "180px",
          background: "rgba(255,255,255,0.04)",
          borderRadius: "50%",
          pointerEvents: "none"
        }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, position: "relative", zIndex: 1 }}>
          {/* Top Title and Date Picker */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box sx={{
                background: "rgba(255,255,255,0.12)",
                p: 1,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                backdropFilter: "blur(4px)"
              }}>
                <LocalHospital sx={{ fontSize: 26, color: "#90caf9" }} />
              </Box>
              <Box>
               
                <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, color: "#ffffff" }}>
                  OPD
                </Typography>
              </Box>
            </Box>

            {/* Date Input Selector */}
            <TextField
              id="date"
              type="date"
              size="small"
              value={datew}
              onChange={(event) => setDate(event.target.value)}
              InputProps={{
                sx: { 
                  color: "white",
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  backgroundColor: "rgba(255,255,255,0.1)",
                  borderRadius: "12px",
                  border: "1px solid rgba(255,255,255,0.2)",
                  height: "38px",
                  px: 0.5,
                  "& input::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)"
                  }
                }
              }}
              sx={{ minWidth: "140px" }}
            />
          </Box>

    
        </Box>
      </Box>

      {/* Patient List Content */}
      <Box sx={{ p: 2, maxWidth: "800px", margin: "0 auto" }}>
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: { borderRadius: "16px", p: 1 }
          }}
        >
          <DialogTitle sx={{ fontWeight: 700, color: "#0a0d25" }}>
            Delete Patient from OPD
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ fontSize: "0.9rem", color: "#555" }}>
              Are you sure you want to delete this patient from the OPD queue? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={handleClose} sx={{ color: "#777", textTransform: "none", fontWeight: 600 }}>
              Cancel
            </Button>
            <Button
              onClick={handleCloseYES}
              variant="contained"
              color="error"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 700,
                px: 3
              }}
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Patient Cards List */}
        {filteredData.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {filteredData.map((item, index) => {
              const tokenDisplay = item.tokenNumber || (index + 1);
              const isApptGiven = item.isApptGiven === true;
              const hasApptRequest = item.nextApptOption && item.nextApptOption !== "none";
              
              // 3 Payment Phases Conditions
              const isApproved = item.status === "approved";
              const hasReceived = item.opdPay !== undefined && item.opdPay !== null && item.opdPay !== "" && Number(item.opdPay) > 0;
              const hasAskPrice = item.askPrice !== undefined && item.askPrice !== null && item.askPrice !== "" && Number(item.askPrice) > 0;

              // Card Border Color Based on Payment Phase
              let cardBorderLeft = "3px solid #cbd5e1"; // Default slate
              if (isApproved) {
                cardBorderLeft = "3px solid #10b981"; // Phase 3: Emerald
              } else if (hasReceived) {
                cardBorderLeft = "3px solid #0284c7"; // Phase 2: Sky Blue
              } else if (hasAskPrice) {
                cardBorderLeft = "3px solid #f43f5e"; // Phase 1: Rose Red
              }

              return (
                <Paper
                  key={item.opdId}
                  elevation={0}
                  sx={{
                    background: "#ffffff",
                    borderRadius: "16px",
                    boxShadow: "0 4px 18px rgba(0, 0, 0, 0.04)",
                    border: "1px solid #e8ecef",
                    borderLeft: cardBorderLeft,
                    overflow: "hidden",
                    p: 2,
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      boxShadow: "0 6px 24px rgba(0, 0, 0, 0.08)"
                    }
                  }}
                >
                  {/* Patient Header Row */}
                  <Box sx={{ mb: 1.5 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                      {/* Left: Token Badge, Avatar, Name & Phone */}
                      <Box 
                        sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
                        onClick={() => {
                          navigate("/profile", {
                            state: {
                              id: item.id,
                              opdId: item.id,
                              ptid: item.id,
                              name: item.ptName || item.name,
                              phoneNumber: item.phNumber || item.phoneNumber,
                              age: item.age,
                              gender: item.gender,
                              totalPaid: item.paid || item.totalPaid,
                            },
                          });
                        }}
                      >
                       

                        {/* Patient Avatar */}
                        <Box sx={{
                          width: 42,
                          height: 42,
                          borderRadius: "50%",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#e3f2fd",
                          border: "2px solid #bbdefb",
                          color: "#1565c0",
                          fontWeight: 700,
                          fontSize: "1rem"
                        }}>
                          {item.photoURL ? (
                            <img
                              src={item.photoURL}
                              alt={item.ptName}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                          ) : (
                            (item.ptName || "P").charAt(0).toUpperCase()
                          )}
                        </Box>

                        {/* Patient Name & Age/Gender */}
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 700,fontSize:"1.2rem", color: "#1a202c", lineHeight: 1.2 }}>
                            {item.ptName || item.name}
                          </Typography>
                          <Typography variant="caption" sx={{ color: "#64748b", display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }}>
                            <Person sx={{ fontSize: "0.85rem", color: "#94a3b8" }} />
                            {item.age} yrs • {item.gender}
                          </Typography>

                          {/* Vitals & Medical History Chips */}
                          {(item.todaysBP || item.eatenSomething || item.medicalHistory) && (
                            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
                              {item.todaysBP && (
                                <Chip
                                  label={`🩸 BP: ${item.todaysBP}`}
                                  size="small"
                                  sx={{ bgcolor: "#fee2e2", color: "#991b1b", fontWeight: 700, fontSize: "0.75rem", height: "22px" }}
                                />
                              )}
                              {item.eatenSomething && (
                                <Chip
                                  label={`🍱 Eaten: ${item.eatenSomething}`}
                                  size="small"
                                  sx={{
                                    bgcolor: item.eatenSomething === "Yes" ? "#dcfce7" : "#fef3c7",
                                    color: item.eatenSomething === "Yes" ? "#166534" : "#92400e",
                                    fontWeight: 700,
                                    fontSize: "0.75rem",
                                    height: "22px"
                                  }}
                                />
                              )}
                              {item.breastfeeding && item.breastfeeding !== "N/A" && item.breastfeeding !== "No" && (
                                <Chip
                                  label={`🤱 Breastfeeding: ${item.breastfeeding}`}
                                  size="small"
                                  sx={{ bgcolor: "#f3e8ff", color: "#6b21a8", fontWeight: 700, fontSize: "0.75rem", height: "22px" }}
                                />
                              )}
                              {item.pregnancy && item.pregnancy !== "N/A" && item.pregnancy !== "No" && (
                                <Chip
                                  label={`🤰 Pregnancy: ${item.pregnancy}`}
                                  size="small"
                                  sx={{ bgcolor: "#fce7f3", color: "#9d174d", fontWeight: 700, fontSize: "0.75rem", height: "22px" }}
                                />
                              )}
                              {item.medicalHistory && (
                                <>
                                  {item.medicalHistory.diabetes && <Chip label="Diabetes" size="small" color="error" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.bp && <Chip label="BP" size="small" color="error" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.heartProblem && <Chip label="Heart" size="small" color="error" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.thyroid && <Chip label="Thyroid" size="small" color="warning" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.allergy && <Chip label="Allergy" size="small" color="warning" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.hepatitis && <Chip label="Hepatitis" size="small" color="error" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.hiv && <Chip label="HIV" size="small" color="error" variant="outlined" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700 }} />}
                                  {item.medicalHistory.bloodThinner && <Chip label="⚠️ Blood Thinner" size="small" sx={{ height: "22px", fontSize: "0.7rem", fontWeight: 700, bgcolor: "#b71c1c", color: "white" }} />}
                                </>
                              )}
                              {item.extraMedication && (
                                <Chip
                                  label={`💊 Meds: ${item.extraMedication}`}
                                  size="small"
                                  sx={{ bgcolor: "#e0f2fe", color: "#0369a1", fontWeight: 700, fontSize: "0.75rem", height: "22px" }}
                                />
                              )}
                            </Box>
                          )}
                        </Box>
                      </Box>

                      {/* Right Actions: Phone Call & Delete Button */}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {item.phNumber && (
                          <Button
                            component="a"
                            href={`tel:${item.phNumber}`}
                            onClick={(e) => e.stopPropagation()}
                            size="small"
                            startIcon={<Phone sx={{ fontSize: "0.9rem !important" }} />}
                            sx={{
                              backgroundColor: "#e8f5e9",
                              color: "#2e7d32",
                              textTransform: "none",
                              fontWeight: 700,
                              fontSize: "0.8rem",
                              borderRadius: "8px",
                              px: 1.2,
                              py: 0.5,
                              "&:hover": { backgroundColor: "#c8e6c9" }
                            }}
                          >
                            {item.phNumber}
                          </Button>
                        )}

                        {item.status !== "approved" && (
                          <IconButton
                            size="small"
                            onClick={() => {
                              setOpdId(item.opdId);
                              setOpen(true);
                            }}
                            sx={{
                              color: "#d32f2f",
                              backgroundColor: "#ffebee",
                              p: 0.75,
                              borderRadius: "8px",
                              "&:hover": { backgroundColor: "#ffcdd2" }
                            }}
                          >
                            <Delete sx={{ fontSize: "1.1rem" }} />
                          </IconButton>
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* THREE PAYMENT PHASES SECTION */}
                  {isApproved ? (
                    /* PHASE 3: PAID & VERIFIED (NON-EDITABLE) */
                    <Box sx={{
                      background: "#f0fdf4",
                      border: "1px solid #dcfce7",
                      borderRadius: "12px",
                      p: 1.25,
                      mb: 1.25,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1
                    }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box>
                        
                          <Typography variant="subtitle1" sx={{ color: "#15803d", fontWeight: 700, fontSize: "0.95rem", display: "flex", alignItems: "center", gap: 0.75 }}>
                            <CheckCircle sx={{ fontSize: "1rem", color: "#16a34a" }} /> Paid: ₹{item.opdPay || item.askPrice || 0}
                            {item.paymentMode && (
                              <Chip label={item.paymentMode} size="small" sx={{ height: "20px", fontSize: "0.65rem", fontWeight: 600, bgcolor: "#dcfce7", color: "#166534" }} />
                            )}
                          </Typography>
                          {item.amountFor && (
                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 500 }}>
                              For: {item.amountFor}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Chip
                        icon={<CheckCircle sx={{ fontSize: "0.85rem !important", color: "#15803d !important" }} />}
                        label="PAID & VERIFIED"
                        size="small"
                        sx={{
                          backgroundColor: "#dcfce7",
                          color: "#15803d",
                          fontWeight: 700,
                          fontSize: "0.72rem",
                          height: "26px",
                          px: 1,
                          border: "1px solid #bbf7d0"
                        }}
                      />
                    </Box>
                  ) : hasReceived ? (
                    /* PHASE 2: RECEIVED THIS MUCH (PENDING ADMIN VERIFICATION - EDITABLE) */
                    <Box sx={{
                      background: "#f0f9ff",
                      border: "1px solid #e0f2fe",
                      borderRadius: "12px",
                      p: 1.25,
                      mb: 1.25,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1
                    }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box>
                          
                          <Typography variant="subtitle1" sx={{ color: "#0369a1", fontWeight: 700, fontSize: "0.95rem", display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
                            Received: ₹{item.opdPay}
                            {item.paymentMode && (
                              <Chip label={item.paymentMode} size="small" sx={{ height: "20px", fontSize: "0.65rem", fontWeight: 600, bgcolor: "#e0f2fe", color: "#0369a1" }} />
                            )}
                          </Typography>
                          
                          {/* ORIGINAL ASKING PRICE DISPLAY */}
                          {hasAskPrice && (
                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 500, fontSize: "0.75rem", mt: 0.25, display: "block" }}>
                              Original Asked: <strong style={{ color: "#e11d48", fontWeight: 600 }}>₹{item.askPrice}</strong>
                            </Typography>
                          )}

                          {item.amountFor && (
                            <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 500, display: "block" }}>
                              For: {item.amountFor}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <OpdPay 
                          id={item.id} 
                          opdId={item.opdId} 
                          askPrice={item.askPrice} 
                          opdPay={item.opdPay}
                          paymentMode={item.paymentMode}
                          status={item.status} 
                          buttonText={`Received ₹ ${item.opdPay}`}
                          buttonStyle={{
                            fontSize: "12px",
                            fontWeight: "600",
                            borderRadius: "18px",
                            border: "1px solid #0284c7",
                            textAlign: "center",
                            padding: "6px 14px",
                            backgroundColor: "#0284c7",
                            color: "white",
                            textTransform: "none",
                            boxShadow: "0 2px 6px rgba(2, 132, 199, 0.2)"
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    /* PHASE 1: PAY THIS MUCH (PAYMENT REQUESTED / PENDING - EDITABLE) */
                    <Box sx={{
                      background: hasAskPrice ? "#fff1f2" : "#f8fafc",
                      border: hasAskPrice ? "1px solid #ffe4e6" : "1px solid #f1f5f9",
                      borderRadius: "12px",
                      p: 1.25,
                      mb: 1.25,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1
                    }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box>
                          {hasAskPrice ? (
                            <>
                              <Typography variant="caption" sx={{ color: "#e11d48", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.65rem", display: "block" }}>
                                PAYMENT REQUESTED
                              </Typography>
                              <Typography variant="subtitle1" sx={{ color: "#be123c", fontWeight: 700, fontSize: "0.95rem" }}>
                                To Pay: ₹{item.askPrice}
                              </Typography>
                              {item.amountFor && (
                                <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 500 }}>
                                  For: {item.amountFor}
                                </Typography>
                              )}
                            </>
                          ) : (
                            <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 500, fontSize: "0.85rem" }}>
                              No payment requested (₹0)
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <OpdPay 
                          id={item.id} 
                          opdId={item.opdId} 
                          askPrice={item.askPrice} 
                          opdPay={item.opdPay}
                          paymentMode={item.paymentMode}
                          status={item.status} 
                          buttonText={hasAskPrice ? `Pay ₹ ${item.askPrice}` : "Pay Fees"}
                          buttonStyle={{
                            fontSize: "12px",
                            fontWeight: "600",
                            borderRadius: "18px",
                            padding: "6px 14px",
                            backgroundColor: "#1e293b",
                            color: "white",
                            textTransform: "none",
                            boxShadow: "0 2px 6px rgba(30, 41, 59, 0.15)"
                          }}
                        />
                      </Box>
                    </Box>
                  )}

                  {/* Next Appointment Section */}
                  <Box sx={{
                    p: 1.25,
                    backgroundColor: "#f8fafc",
                    borderRadius: "12px",
                    border: "1px solid #f1f5f9"
                  }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.75, flexWrap: "wrap", gap: 1 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Event sx={{ fontSize: "1rem", color: "#334155" }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#334155", fontSize: "0.82rem" }}>
                          Next Appointment
                        </Typography>
                      </Box>

                      {/* CONDITIONAL APPOINTMENT BADGES & ACTION BUTTON */}
                      {isApptGiven ? (
                        <Chip
                          icon={<CheckCircle sx={{ fontSize: "0.85rem !important", color: "#15803d !important" }} />}
                          label="✔ Appointment Given"
                          size="small"
                          sx={{
                            backgroundColor: "#f0fdf4",
                            color: "#15803d",
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            height: "26px",
                            px: 0.5,
                            border: "1px solid #bbf7d0"
                          }}
                        />
                      ) : hasApptRequest ? (
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                          <Chip
                            label="📌 Appointment Requested"
                            size="small"
                            sx={{
                              backgroundColor: "#fff7ed",
                              color: "#c2410c",
                              fontWeight: 700,
                              fontSize: "0.75rem",
                              height: "26px",
                              px: 0.5,
                              border: "1px solid #ffedd5"
                            }}
                          />
                          <Button
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/appointment", {
                                state: {
                                  name: item.ptName || item.name || "",
                                  phoneNumber: item.phNumber || item.phoneNumber || "",
                                  id: item.id || item.ptId || "",
                                  originalptId: item.originalptId || item.id || "",
                                  photoURL: item.photoURL || "",
                                  reason: item.nextApptWork || "",
                                  nextApptWork: item.nextApptWork || "",
                                  date: item.nextApptDate || "",
                                  nextApptDate: item.nextApptDate || "",
                                  duration: item.nextApptDuration || "",
                                  nextApptDuration: item.nextApptDuration || "",
                                  nextApptOption: item.nextApptOption || "treatment",
                                  nextApptType: item.nextApptType || "Treatment",
                                  opdId: item.opdId,
                                }
                              });
                            }}
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              textTransform: "none",
                              borderRadius: "18px",
                              background: "linear-gradient(135deg, rgb(5, 2, 43), rgb(20, 30, 80))",
                              color: "white",
                              px: 1.5,
                              py: 0.4
                            }}
                          >
                            Give Appointment
                          </Button>
                        </Box>
                      ) : (
                        <Button
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/appointment", {
                              state: {
                                name: item.ptName || item.name || "",
                                phoneNumber: item.phNumber || item.phoneNumber || "",
                                id: item.id || item.ptId || "",
                                originalptId: item.originalptId || item.id || "",
                                photoURL: item.photoURL || "",
                                opdId: item.opdId,
                              }
                            });
                          }}
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: "18px",
                            background: "linear-gradient(135deg, rgb(5, 2, 43), rgb(20, 30, 80))",
                            color: "white",
                            px: 1.5,
                            py: 0.4
                          }}
                        >
                          Give Appointment
                        </Button>
                      )}
                    </Box>

                    {/* Details if appointment is requested or given */}
                    {hasApptRequest ? (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/appointment", {
                            state: {
                              name: item.ptName || item.name || "",
                              phoneNumber: item.phNumber || item.phoneNumber || "",
                              id: item.id || item.ptId || "",
                              originalptId: item.originalptId || item.id || "",
                              photoURL: item.photoURL || "",
                              reason: item.nextApptWork || "",
                              nextApptWork: item.nextApptWork || "",
                              date: item.nextApptDate || "",
                              nextApptDate: item.nextApptDate || "",
                              duration: item.nextApptDuration || "",
                              nextApptDuration: item.nextApptDuration || "",
                              nextApptOption: item.nextApptOption || "treatment",
                              nextApptType: item.nextApptType || "Treatment",
                              opdId: item.opdId,
                            }
                          });
                        }}
                        sx={{ display: "flex", flexDirection: "column", gap: 0.5, cursor: "pointer", mt: 0.5 }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
                          <Chip
                            label={item.nextApptType || (item.nextApptOption === "treatment" ? "Treatment" : "Follow-Up")}
                            size="small"
                            sx={{
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              height: "22px",
                              backgroundColor: item.nextApptOption === "treatment" ? "#e0f2fe" : "#ccfbf1",
                              color: item.nextApptOption === "treatment" ? "#0369a1" : "#0f766e",
                              border: item.nextApptOption === "treatment" ? "1px solid #bae6fd" : "1px solid #99f6e4"
                            }}
                          />

                          {item.nextApptDate && (
                            <Typography variant="caption" sx={{ fontWeight: 600, color: "#15803d", fontSize: "0.75rem" }}>
                              📅 {item.nextApptDate}
                            </Typography>
                          )}

                          {item.nextApptDuration && (
                            <Chip
                              label={`⏱️ ${item.nextApptDuration}`}
                              size="small"
                              sx={{
                                fontSize: "0.68rem",
                                height: "20px",
                                bgcolor: "#dcfce7",
                                color: "#15803d",
                                fontWeight: 600
                              }}
                            />
                          )}
                        </Box>

                        {item.nextApptWork && (
                          <Box sx={{
                            fontSize: "0.78rem",
                            color: "#334155",
                            backgroundColor: "#ffffff",
                            p: 0.75,
                            borderRadius: "6px",
                            borderLeft: isApptGiven ? "3px solid #10b981" : "3px solid #f97316"
                          }}>
                            <strong style={{ color: isApptGiven ? "#15803d" : "#c2410c" }}>Procedure:</strong> {item.nextApptWork}
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Typography variant="caption" sx={{ color: "#94a3b8", fontStyle: "italic", fontSize: "0.75rem" }}>
                        No next appointment scheduled yet
                      </Typography>
                    )}
                  </Box>
                </Paper>
              );
            })}
          </Box>
        ) : (
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: "center",
              borderRadius: "16px",
              backgroundColor: "#ffffff",
              border: "1px solid #e8ecef"
            }}
          >
            <MedicalServices sx={{ fontSize: 48, color: "#cbd5e1", mb: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#475569" }}>
              No OPD Entries Found
            </Typography>
            <Typography variant="body2" sx={{ color: "#94a3b8", mt: 0.5 }}>
              {searchQuery ? "No patients matching search query" : "No patients registered for this date"}
            </Typography>
          </Paper>
        )}
      </Box>

      {/* Floating Action Button */}
      <Box
        sx={{
          position: "fixed",
          bottom: "80px",
          right: "20px",
          zIndex: 1000
        }}
      >
        <Button
          variant="contained"
          startIcon={<Add sx={{ fontSize: "1.3rem !important" }} />}
          onClick={() => {
            navigate("/newopdstart", {
              state: {
                id: "1",
              },
            });
          }}
          sx={{
            background: "linear-gradient(135deg, rgb(5, 2, 43) 0%, rgb(20, 30, 80) 100%)",
            color: "white",
            px: 2.5,
            py: 1.25,
            borderRadius: "30px",
            fontSize: "0.9rem",
            fontWeight: 800,
            textTransform: "none",
            boxShadow: "0 6px 20px rgba(5, 2, 43, 0.4)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              background: "linear-gradient(135deg, rgb(10, 5, 60) 0%, rgb(30, 42, 100))",
              transform: "scale(1.03)"
            }
          }}
        >
          Start New OPD
        </Button>
      </Box>
    </Box>
  );
}

export default Opd;
